import type { ReactNode } from 'react';

interface BadgeProps {
  variant?: 'good' | 'rare' | 'exceptional' | 'info' | 'neutral';
  size?: 'sm' | 'md';
  children: ReactNode;
  className?: string;
}

const variantClasses: Record<NonNullable<BadgeProps['variant']>, string> = {
  good: 'bg-gradient-to-br from-amber-200 to-amber-700 text-amber-50 ring-1 ring-amber-800/30',
  rare: 'bg-gradient-to-br from-slate-200 to-slate-400 text-slate-800 ring-1 ring-slate-500/40',
  exceptional: 'bg-gradient-to-br from-yellow-200 to-yellow-500 text-yellow-900 ring-1 ring-yellow-700/40',
  info: 'bg-primary-100 text-primary-700',
  neutral: 'bg-gray-100 text-gray-700',
};

const sizeClasses: Record<NonNullable<BadgeProps['size']>, string> = {
  sm: 'px-1.5 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-xs',
};

export function Badge({
  variant = 'neutral',
  size = 'md',
  children,
  className = '',
}: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
    >
      {children}
    </span>
  );
}
